import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import actionCreators from "../../actionCreators/index.js";
import TransactionUtilityBar from "./transaction-utility-bar";

function mapStateToProps(state) {
  return {
    transactionRequest: state.transactionRequest,
    transactions: state.transactions,
    bids: state.bids,
    paymentType: state.paymentType,
    paymentMethod: state.paymentMethod,
    error: state.error,
    selectedAccordion: state.selectedAccordion,
    isSimulateMode: state.isSimulateMode,
    actionType: state.actionType,
    userDetails: state.userDetails,
    simulatedUserDetails: state.simulatedUserDetails,
    businessActivities: state.businessActivities,
    simulatedBusinessActivities: state.simulatedBusinessActivities,
    texts : state.translatedTexts,
    transactionAttachments : state.transactionAttachments,
    createTransactionAttachmentsResponse: state.createTransactionAttachmentsResponse,
    transactionAttachmentResponse : state.transactionAttachmentResponse,
    transactionStatus: state.transactionStatus,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TransactionUtilityBar);
